var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLevelRoundEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Table_EV_Level_Icon",
    "data-name": "Table EV Level Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.086,
    height: 34.086,
    viewBox: "0 0 34.086 34.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5693",
    "data-name": "Path 5693",
    d: "M17.043,0A17.043,17.043,0,1,1,0,17.043,17.043,17.043,0,0,1,17.043,0Z",
    transform: "translate(0 0)",
    fill: "#005a2b",
    opacity: 0.047
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M14.391,0A14.391,14.391,0,1,1,0,14.391,14.391,14.391,0,0,1,14.391,0Z",
    transform: "translate(2.608 2.697)",
    fill: "#e8e8e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M4348.345,2182.594h-.2a4.631,4.631,0,0,1-1.729-.416,4.939,4.939,0,0,1-1.626-1.1,10.124,10.124,0,0,1-2.557-4.624,1.907,1.907,0,0,1-.562-.477,3.069,3.069,0,0,1-.648-1.8,5.109,5.109,0,0,1,.169-1.929,2.787,2.787,0,0,1,.631-1.023v-1.1a6.992,6.992,0,0,1,.822-3.827,5.6,5.6,0,0,1,1.728-1.685,7.4,7.4,0,0,1,3.638-.867h.427a7.451,7.451,0,0,1,3.674.862,5.6,5.6,0,0,1,1.739,1.691,6.99,6.99,0,0,1,.822,3.827v1.1a2.79,2.79,0,0,1,.631,1.023,5.092,5.092,0,0,1,.168,1.929,3.162,3.162,0,0,1-.647,1.8,1.834,1.834,0,0,1-.562.477,10.126,10.126,0,0,1-2.556,4.624A5.284,5.284,0,0,1,4348.345,2182.594Zm-6.1-10.352h0a2.75,2.75,0,0,0-.278,1.542,2.375,2.375,0,0,0,.526,1.566,1.653,1.653,0,0,0,.525.413,11.348,11.348,0,0,0,2.221,4.439,4.588,4.588,0,0,0,2.915,1.312h.177a4.586,4.586,0,0,0,2.915-1.312,11.341,11.341,0,0,0,2.222-4.439,1.6,1.6,0,0,0,.525-.413,2.312,2.312,0,0,0,.526-1.566,2.726,2.726,0,0,0-.283-1.549l-.749,1.016a1.819,1.819,0,0,1-1.393.7,2.005,2.005,0,0,1-.692-.131l-.1-.036,0,0a7.9,7.9,0,0,0-3.019-.722h-.083a7.912,7.912,0,0,0-3.025.724l-.1.035a2,2,0,0,1-.692.131,1.81,1.81,0,0,1-1.393-.7l-.75-1.01Zm5.919-1.449a14.64,14.64,0,0,0-3.838.47,6.822,6.822,0,0,0-1.3.47l.029.037c.542.691.722.938.777,1.023a.552.552,0,0,0,.473.188,1.4,1.4,0,0,0,.3-.034,2.525,2.525,0,0,0,.406-.137c.165-.065.39-.155.764-.28a7.274,7.274,0,0,1,2.234-.423l.456,0a7.252,7.252,0,0,1,2.187.421c.373.125.6.214.763.279h0a2.559,2.559,0,0,0,.405.137,1.411,1.411,0,0,0,.3.034.552.552,0,0,0,.473-.188c.138-.211.8-1.052.807-1.06a6.8,6.8,0,0,0-1.295-.47,14.646,14.646,0,0,0-3.838-.47Z",
    transform: "translate(-4331.243 -2156.084)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevelRoundEmpty);
export default __webpack_public_path__ + "static/media/icon_level_round_empty.4768831f7411cfae22fd8f865576549f.svg";
export { ForwardRef as ReactComponent };